// removed by extract-text-webpack-plugin
module.exports = {"mod_default":"AjOu-","folded":"_10ayW","buttonArrowLeft":"_-o3bh _2AI_i","buttonArrowRight":"_2sH9e _2AI_i","button":"_1YEBm","buttonText":"_8nViH","buttonArrow":"_3RLZW","caret":"_2AI_i"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Faktavit/styles.scss
 ** module id = 452
 ** module chunks = 0
 **/